// import useMOCToastService from '../use-moc-toast-service';
import {useToast} from '@sttedra_ui/framework';
import {errorToastOptions} from '@/util-toast';

const sttedraToastService = useToast();

export default function useHandleMOCError() {
  const handleMOCError = (error,
    toastOptions = errorToastOptions()) => {
    let {message} = toastOptions;
    if (!!error?.response?.data?.error) {
      message = error.response.data.error;
    }
    if (!!error?.response?.data?.message) {
      message = error.response.data.message;
    }
    const toastOpts = {...toastOptions, message};
    sttedraToastService.add(toastOpts);
  };

  // Pre: api returns promise
  const wrapApiMOCError = (api, toastOptions = errorToastOptions()) => {
    return async function(args) {
      try {
        const res = await api(args);
        return res;
      } catch (err) {
        handleMOCError(err, toastOptions);
      }
    };
  };
  return {
    handleMOCError,
    wrapApiMOCError,
  };
}
